import type {SketchCircleObject} from '../sketch/SketchCircleObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图圆对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图圆协议时返回 true。
 */
export function isSketchCircleObject(value: unknown): value is SketchCircleObject {
	// 基于对象标记字段进行判定。
	return hasRuntimeFlag(value, 'isSketchCircleObject');
}
